import { render, staticRenderFns } from "./POSobjekatCRUD.vue?vue&type=template&id=f10c9ab6"
import script from "./POSobjekatCRUD.vue?vue&type=script&lang=js"
export * from "./POSobjekatCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports